// src/data/scoutingReports.js
// Seed map for scouting reports. Local edits merge via localStorage.

export const SCOUTING_REPORTS = {
  // Raymond Ortiz
  'raymond-ortiz': {
    pitcherId: 'raymond-ortiz',
    name: 'Raymond Ortiz',
    lastUpdated: new Date().toISOString(),
    ageSize: '21 • 6\'1" • 190 lbs • R',
    stats: '3.48 ERA | 1.30 WHIP | 9.8 K/9 | 3.4 BB/9',
    overallFV: 50,
    risk: 'Medium',
    roleProjection: 'Mid-Round Starter',
    pitches: {
      fourSeam: { present: 55, future: 60, usage: 40, notes: 'FB 90–93 T95 rides at the letters' },
      slider: { present: 45, future: 50, usage: 25, notes: 'SL flashes but needs shape tightening' },
      changeup: { present: 50, future: 55, usage: 30, notes: 'CH tunnels with late fade and kills bats vs opposite side' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 45, future: 50 },
      athleticism: { present: 55, future: 55 },
      delivery: { present: 50, future: 55 },
      fielding: { present: null, future: null }
    },
    summary: 'Athletic RHP with carry FB and advanced CH feel. FB 90–93 T95 rides at the letters; CH tunnels with late fade and kills bats vs opposite side. SL flashes but needs shape tightening. Above-average command for his level. Mid-round starter profile if slider matures.',
    keyStrengths: 'FB ride; Plus-projection CH',
    mainConcerns: 'SL depth/consistency; Needs strength for late outings',
    developmentFocus: 'Slider sweep/bite work; Maintain CH arm speed at higher intents'
  },

  // Alex Blair
  'alex-blair': {
    pitcherId: 'alex-blair',
    name: 'Alex Blair',
    lastUpdated: new Date().toISOString(),
    ageSize: '21 • 6\'2" • 190 lbs • R',
    stats: '3.25 ERA | 1.22 WHIP | 9.8 K/9 | 2.8 BB/9',
    overallFV: 55,
    risk: 'Medium',
    roleProjection: 'Backend Starter',
    pitches: {
      fourSeam: { present: 55, future: 60, usage: 40, notes: 'FB sits 94-96 T97 with carry' },
      slider: { present: 50, future: 55, usage: 30, notes: 'SL flashes plus potential' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'CH developing with fade' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB fringe offering' }
    },
    tools: {
      command: { present: 50, future: 55 },
      control: { present: 45, future: 50 },
      athleticism: { present: 55, future: 55 },
      delivery: { present: 50, future: 55 },
      fielding: { present: null, future: null }
    },
    summary: 'Athletic RHP with above-average velocity and advanced command. FB sits 94-96 T97 with good life and command. SL has plus potential with tight break. CH developing nicely with fade and arm speed. Command is above-average and trending upward. Projects as mid-rotation starter with upside.',
    keyStrengths: 'Above-average velocity; Advanced command; Plus slider potential',
    mainConcerns: 'Maintain stuff vs. higher levels; Secondary consistency',
    developmentFocus: 'Command refinement; Continue slider development'
  },

  // David Bennett
  'david-bennett': {
    pitcherId: 'david-bennett',
    name: 'David Bennett',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'1" • 185 lbs • R',
    stats: '4.15 ERA | 1.45 WHIP | 7.5 K/9 | 3.8 BB/9',
    overallFV: 35,
    risk: 'High',
    roleProjection: 'Organizational Depth',
    pitches: {
      fourSeam: { present: 45, future: 45, usage: 45, notes: 'Fastball 87–90 (T91) shows limited life and plays below average' },
      slider: { present: 40, future: 40, usage: 25, notes: 'Secondary pitches are all fringy, lacking consistent shape' },
      changeup: { present: 40, future: 40, usage: 25, notes: 'Secondary pitches are all fringy, lacking swing-and-miss quality' },
      curveball: { present: 35, future: 35, usage: 5, notes: 'Command inconsistencies further cap the profile' }
    },
    tools: {
      command: { present: 40, future: 40 },
      control: { present: 35, future: 35 },
      athleticism: { present: 40, future: 40 },
      delivery: { present: 40, future: 40 },
      fielding: { present: null, future: null }
    },
    summary: 'College RHP with fringy stuff across the board. Fastball 87–90 (T91) shows limited life and plays below average. Secondary pitches are all fringy, lacking consistent shape or swing-and-miss quality. Command inconsistencies further cap the profile, leaving little projection. Projects as organizational depth piece without a true carrying tool.',
    keyStrengths: 'College experience; Competitive makeup',
    mainConcerns: 'Below-average stuff; Poor command and control',
    developmentFocus: 'Major command overhaul; Pitch refinement'
  },

  // Chris Clark
  'chris-clark': {
    pitcherId: 'chris-clark',
    name: 'Chris Clark',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'3" • 200 lbs • R',
    stats: '3.85 ERA | 1.38 WHIP | 8.2 K/9 | 3.5 BB/9',
    overallFV: 40,
    risk: 'Medium',
    roleProjection: 'Middle Relief',
    pitches: {
      fourSeam: { present: 50, future: 50, usage: 50, notes: 'FB 89-92 T94 with sink' },
      slider: { present: 45, future: 50, usage: 35, notes: 'SL flashes average' },
      changeup: { present: 40, future: 45, usage: 15, notes: 'CH developing' },
      curveball: { present: 35, future: 40, usage: 0, notes: 'CB rarely used' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Physical RHP with solid frame and improving stuff. FB 89-92 T94 shows sink, SL has potential to be average. Command is workable but needs refinement. Projects best in middle relief role.',
    keyStrengths: 'Good frame; Fastball sink; Improving slider',
    mainConcerns: 'Command consistency; Limited third pitch',
    developmentFocus: 'Refine command; Develop changeup'
  },

  // Ryan Dean
  'ryan-dean': {
    pitcherId: 'ryan-dean',
    name: 'Ryan Dean',
    lastUpdated: new Date().toISOString(),
    ageSize: '20 • 6\'0" • 175 lbs • L',
    stats: '4.25 ERA | 1.52 WHIP | 6.8 K/9 | 4.2 BB/9',
    overallFV: 30,
    risk: 'High',
    roleProjection: 'Development Project',
    pitches: {
      fourSeam: { present: 40, future: 45, usage: 40, notes: 'FB 85-88 T89 lacks carry' },
      slider: { present: 35, future: 40, usage: 30, notes: 'SL fringe' },
      changeup: { present: 40, future: 45, usage: 25, notes: 'CH shows fade vs RHH' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 30, future: 35 },
      athleticism: { present: 45, future: 50 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Young LHP with projection but limited present stuff. FB 85-88 T89 lacks carry, secondaries are fringe. Command issues are significant. Appeal is youth and left-handedness, but needs major development.',
    keyStrengths: 'Young age (20); Left-handed; Some projection',
    mainConcerns: 'Below-average stuff; Poor command/control',
    developmentFocus: 'Velocity gains; Complete command overhaul'
  },

  // Josh Doyle
  'josh-doyle': {
    pitcherId: 'josh-doyle',
    name: 'Josh Doyle',
    lastUpdated: new Date().toISOString(),
    ageSize: '24 • 5\'11" • 180 lbs • R',
    stats: '5.15 ERA | 1.68 WHIP | 6.2 K/9 | 4.8 BB/9',
    overallFV: 25,
    risk: 'Extreme',
    roleProjection: 'Non-Prospect',
    pitches: {
      fourSeam: { present: 35, future: 35, usage: 45, notes: 'FB 83-86 T87 light' },
      slider: { present: 35, future: 35, usage: 25, notes: 'SL lacks bite' },
      changeup: { present: 35, future: 35, usage: 25, notes: 'CH lacks deception' },
      curveball: { present: 30, future: 30, usage: 5, notes: 'CB well below-average' }
    },
    tools: {
      command: { present: 30, future: 30 },
      control: { present: 25, future: 25 },
      athleticism: { present: 35, future: 35 },
      delivery: { present: 35, future: 35 },
      fielding: { present: null, future: null }
    },
    summary: 'Older RHP with well below-average stuff across the board. FB 83-86 T87 is light, secondaries lack definition. Command and control are poor. Age and limited tools suggest non-prospect status.',
    keyStrengths: 'College experience; Competitive spirit',
    mainConcerns: 'Well below-average stuff; Age; Poor command',
    developmentFocus: 'Consider position change; Complete overhaul needed'
  },
  // Trevor Evans
  'trevor-evans': {
    pitcherId: 'trevor-evans',
    name: 'Trevor Evans',
    lastUpdated: new Date().toISOString(),
    ageSize: '21 • 6\'4" • 210 lbs • R',
    stats: '2.95 ERA | 1.15 WHIP | 11.2 K/9 | 2.5 BB/9',
    overallFV: 50,
    risk: 'Medium',
    roleProjection: 'Mid-Rotation Starter',
    pitches: {
      fourSeam: { present: 60, future: 60, usage: 45, notes: 'FB 92-95 T97 with plus carry' },
      slider: { present: 55, future: 60, usage: 30, notes: 'SL plus pitch with sharp break' },
      changeup: { present: 50, future: 55, usage: 20, notes: 'CH solid with fade' },
      curveball: { present: 45, future: 50, usage: 5, notes: 'CB developing depth' }
    },
    tools: {
      command: { present: 55, future: 60 },
      control: { present: 50, future: 55 },
      athleticism: { present: 60, future: 60 },
      delivery: { present: 55, future: 60 },
      fielding: { present: null, future: null }
    },
    summary: 'Premium prospect with excellent frame and stuff. FB 92-95 T97 with plus carry, SL is plus pitch with sharp break. CH is solid and developing. Command is above-average for age. Projects as mid-rotation starter with upside.',
    keyStrengths: 'Plus velocity; Plus slider; Excellent frame; Good command',
    mainConcerns: 'Durability questions; Needs to maintain stuff',
    developmentFocus: 'Continue development; Maintain delivery consistency'
  },


  // Jake Ellis
  'jake-ellis': {
    pitcherId: 'jake-ellis',
    name: 'Jake Ellis',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'2" • 195 lbs • R',
    stats: '3.58 ERA | 1.34 WHIP | 8.8 K/9 | 3.4 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Depth/Bullpen',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 40, notes: 'FB 89–92 T94 shows late life' },
      slider: { present: 45, future: 50, usage: 30, notes: 'SL flashes average tilt' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'CH maintains arm speed with occasional fade' },
      curveball: { present: 45, future: 50, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 45, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Solid RHP with usable velocity and developing pitchability. FB 89–92 T94 shows late life. SL flashes average tilt, CH maintains arm speed with occasional fade. Still fringy command, but trending upward. Profiles as a reliable org depth arm with a chance to carve a bullpen role if secondaries firm up.',
    keyStrengths: 'Good FB life; Developing 3-pitch mix',
    mainConcerns: 'Command consistency; Breaking balls need work',
    developmentFocus: 'Improve command/control; Continue breaking ball development'
  },

  // Blake Kane
  'blake-kane': {
    pitcherId: 'blake-kane',
    name: 'Blake Kane',
    lastUpdated: new Date().toISOString(),
    ageSize: '20 • 6\'0" • 175 lbs • R',
    stats: '4.85 ERA | 1.65 WHIP | 6.2 K/9 | 4.9 BB/9',
    overallFV: 35,
    risk: 'High',
    roleProjection: 'Deep-Development Project',
    pitches: {
      fourSeam: { present: 40, future: 45, usage: 45, notes: 'FB 84–87 T88 lacks carry or sink' },
      slider: { present: 35, future: 40, usage: 25, notes: 'SL and CH remain below average with limited feel' },
      changeup: { present: 35, future: 40, usage: 25, notes: 'SL and CH remain below average with limited feel' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 30, future: 35 },
      athleticism: { present: 45, future: 50 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Young RHP with light stuff and erratic strike throwing. FB 84–87 T88 lacks carry or sink. SL and CH remain below average with limited feel. High walk totals underscore control concerns. Requires substantial physical gains and mechanical cleanup. Deep-development prospect only.',
    keyStrengths: 'Young age (20); Room for physical growth',
    mainConcerns: 'Well below-average velo; Poor command/control',
    developmentFocus: 'Major velocity gains needed; Complete command overhaul'
  },

  // Codi Knight
  'codi-knight': {
    pitcherId: 'codi-knight',
    name: 'Codi Knight',
    lastUpdated: new Date().toISOString(),
    ageSize: '21 • 6\'1" • 180 lbs • R',
    stats: '4.78 ERA | 1.58 WHIP | 6.9 K/9 | 4.6 BB/9',
    overallFV: 35,
    risk: 'High',
    roleProjection: 'Development Project',
    pitches: {
      fourSeam: { present: 40, future: 45, usage: 40, notes: 'FB 85–88 T89 comes in flat' },
      slider: { present: 35, future: 40, usage: 25, notes: 'Breaking ball shapes inconsistent, often backed-up' },
      changeup: { present: 40, future: 45, usage: 30, notes: 'CH flashes occasional separation but not reliable' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Breaking ball shapes inconsistent' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 30, future: 35 },
      athleticism: { present: 45, future: 50 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Lean RHP with below-average present stuff but some projection. FB 85–88 T89 comes in flat. Breaking ball shapes inconsistent, often backed-up. CH flashes occasional separation but not reliable. Walks pile up with scattered command. Needs strength gains and delivery refinement to create a pro path.',
    keyStrengths: 'Young age (21); Some projection remaining',
    mainConcerns: 'Below-average velo; Poor command/control',
    developmentFocus: 'Major command overhaul; Simplify delivery'
  },

  // Preston Lewis
  'preston-lewis': {
    pitcherId: 'preston-lewis',
    name: 'Preston Lewis',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'2" • 190 lbs • R',
    stats: '4.25 ERA | 1.48 WHIP | 7.8 K/9 | 4.1 BB/9',
    overallFV: 40,
    risk: 'High',
    roleProjection: 'Organizational Depth',
    pitches: {
      fourSeam: { present: 45, future: 50, usage: 40, notes: 'FB 87–90 T91 shows little life' },
      slider: { present: 40, future: 45, usage: 25, notes: 'SL lacks bite' },
      changeup: { present: 45, future: 50, usage: 30, notes: 'CH flashes but drifts arm-side' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 35, future: 40 },
      athleticism: { present: 45, future: 45 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'College RHP with fringe velocity (87–90 T91) and inconsistent execution. FB shows little life, SL lacks bite, CH flashes but drifts arm-side. Below-average command keeps profile limited. Fits best as an org depth type who can eat innings but lacks impact traits.',
    keyStrengths: 'Decent size; Some college experience',
    mainConcerns: 'Fringe velo; Poor command/control',
    developmentFocus: 'Major command overhaul; Improve delivery consistency'
  },

  // Jackson Long
  'jackson-long': {
    pitcherId: 'jackson-long',
    name: 'Jackson Long',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'0" • 175 lbs • R',
    stats: '4.95 ERA | 1.62 WHIP | 6.5 K/9 | 4.8 BB/9',
    overallFV: 35,
    risk: 'High',
    roleProjection: 'Organizational Filler',
    pitches: {
      fourSeam: { present: 40, future: 45, usage: 40, notes: 'FB 85–88 T89 plays flat' },
      slider: { present: 35, future: 40, usage: 25, notes: 'Secondaries lack bite or separation' },
      changeup: { present: 40, future: 45, usage: 30, notes: 'Secondaries lack bite or separation' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Secondaries lack bite or separation' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 30, future: 35 },
      athleticism: { present: 40, future: 40 },
      delivery: { present: 40, future: 40 },
      fielding: { present: null, future: null }
    },
    summary: 'Righty with below-average stuff and command issues. FB 85–88 T89 plays flat. Secondaries lack bite or separation. High walk totals and hittability limit upside. Competitive makeup shows, but metrics point to organizational filler without notable projection left.',
    keyStrengths: 'Some college experience; Competitive makeup',
    mainConcerns: 'Below-average velo; Poor command/control',
    developmentFocus: 'Major command overhaul; Simplify delivery'
  },

  // Drew Marsh
  'drew-marsh': {
    pitcherId: 'drew-marsh',
    name: 'Drew Marsh',
    lastUpdated: new Date().toISOString(),
    ageSize: '24 • 5\'10" • 170 lbs • R',
    stats: '5.45 ERA | 1.72 WHIP | 5.8 K/9 | 5.2 BB/9',
    overallFV: 35,
    risk: 'Extreme',
    roleProjection: 'Conversion Candidate/Non-Prospect',
    pitches: {
      fourSeam: { present: 35, future: 40, usage: 40, notes: 'FB 83–86 T87 is light' },
      slider: { present: 40, future: 45, usage: 25, notes: 'Secondaries lack finish' },
      changeup: { present: 35, future: 40, usage: 30, notes: 'Secondaries lack finish' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Secondaries lack finish' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 30, future: 35 },
      athleticism: { present: 35, future: 35 },
      delivery: { present: 35, future: 35 },
      fielding: { present: null, future: null }
    },
    summary: 'Undersized RHP with limited present tools. FB 83–86 T87 is light, secondaries lack finish, and command is well below average. Struggles to miss bats or throw strikes consistently. Competitive, but physical limitations and performance indicators suggest a conversion candidate or non-prospect.',
    keyStrengths: 'Competitive spirit; Some college experience',
    mainConcerns: 'Well below-average velo; Poor command/control',
    developmentFocus: 'Consider position change; Major velocity gains needed'
  },

  // Connor Mason
  'connor-mason': {
    pitcherId: 'connor-mason',
    name: 'Connor Mason',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'3" • 205 lbs • R',
    stats: '3.42 ERA | 1.33 WHIP | 9.5 K/9 | 3.2 BB/9',
    overallFV: 50,
    risk: 'Medium',
    roleProjection: 'Mid-Round Starter',
    pitches: {
      fourSeam: { present: 55, future: 60, usage: 45, notes: 'FB 91–94 T96 carries through the zone with late hop and occasional cut' },
      slider: { present: 50, future: 55, usage: 30, notes: 'SL flashes sharp bite' },
      changeup: { present: 45, future: 50, usage: 20, notes: 'CH developing with solid arm speed' },
      curveball: { present: 45, future: 50, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 55, future: 55 },
      delivery: { present: 50, future: 55 },
      fielding: { present: null, future: null }
    },
    summary: 'Physical RHP with pro body and real velocity. FB 91–94 T96 carries through the zone with late hop and occasional cut. SL flashes sharp bite, CH developing with solid arm speed. Command is loose but improving. Size, velocity, and raw stuff give him mid-round draft appeal if consistency sharpens.',
    keyStrengths: 'Good velocity (91–94); Large projectable frame',
    mainConcerns: 'Below-average command; Inconsistent secondaries',
    developmentFocus: 'Improve command/control; Continue slider development'
  },

  // Miles Newman
  'miles-newman': {
    pitcherId: 'miles-newman',
    name: 'Miles Newman',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'1" • 185 lbs • R',
    stats: '3.68 ERA | 1.36 WHIP | 8.9 K/9 | 3.3 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Depth',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 40, notes: 'FB 89–92 T94 with late life' },
      slider: { present: 45, future: 50, usage: 25, notes: 'SL flashes average with occasional depth' },
      changeup: { present: 45, future: 50, usage: 30, notes: 'CH comes with arm speed and fade' },
      curveball: { present: 45, future: 50, usage: 5, notes: 'CB developing' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 45, future: 45 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Solid RHP with playable stuff across the board. FB 89–92 T94 with late life, SL flashes average with occasional depth, CH comes with arm speed and fade. Below-average command, but showing improvement. Age relative to class caps projection, yet he has enough to be a potential org arm with depth value.',
    keyStrengths: 'Good fastball life; Developing three-pitch mix',
    mainConcerns: 'Age for draft class; Command consistency',
    developmentFocus: 'Improve command/control; Continue breaking ball development'
  },

  // Luke Zimmerman
  'luke-zimmerman': {
    pitcherId: 'luke-zimmerman',
    name: 'Luke Zimmerman',
    lastUpdated: new Date().toISOString(),
    ageSize: '19 • 6\'0" • 175 lbs • L',
    stats: '4.75 ERA | 1.42 WHIP | 7.1 K/9 | 3.8 BB/9',
    overallFV: 40,
    risk: 'High',
    roleProjection: 'Development Project',
    pitches: {
      fourSeam: { present: 40, future: 45, usage: 50, notes: 'FB sits 86–89 with modest carry, could tick up with strength gains' },
      slider: { present: 45, future: 50, usage: 30, notes: 'SL shows occasional bite and projects as average with refinement' },
      changeup: { present: 40, future: 45, usage: 15, notes: 'Secondary pitches lag behind, but there\'s some feel for spin' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Secondary pitches lag behind' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 55 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Young lefty with a lean frame and flashes of projection. FB sits 86–89 with modest carry, could tick up with strength gains. SL shows occasional bite and projects as average with refinement. Secondary pitches lag behind, but there\'s some feel for spin. Command is inconsistent but workable. Development path hinges on adding strength and repeating delivery.',
    keyStrengths: 'Projectable frame; Flashes of slider feel',
    mainConcerns: 'Below-average present stuff; Inconsistent strike throwing',
    developmentFocus: 'Add strength/velo; Improve secondary consistency'
  },

  // Jason Young
  'jason-young': {
    pitcherId: 'jason-young',
    name: 'Jason Young',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'2" • 200 lbs • L',
    stats: '4.60 ERA | 1.38 WHIP | 7.9 K/9 | 3.7 BB/9',
    overallFV: 40,
    risk: 'Medium',
    roleProjection: 'Organizational Depth',
    pitches: {
      fourSeam: { present: 45, future: 45, usage: 45, notes: 'Physical left-hander with average FB at 87–90 mph and some natural arm-side run' },
      slider: { present: 40, future: 45, usage: 25, notes: 'SL and CB are playable but lack impact' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'CH is his best secondary, flashing tumble and fade against RHH' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'SL and CB are playable but lack impact' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Physical left-hander with average FB at 87–90 mph and some natural arm-side run. CH is his best secondary, flashing tumble and fade against RHH. SL and CB are playable but lack impact. Projects as org depth with the chance to contribute as a matchup LHP if secondaries sharpen.',
    keyStrengths: 'Physical frame; Changeup flashes average',
    mainConcerns: 'Lacks impact pitch; Inconsistent execution',
    developmentFocus: 'Refine changeup; Improve pitch sequencing'
  },

  // Leo West
  'leo-west': {
    pitcherId: 'leo-west',
    name: 'Leo West',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'2" • 170 lbs • L',
    stats: '5.10 ERA | 1.50 WHIP | 6.8 K/9 | 4.0 BB/9',
    overallFV: 35,
    risk: 'High',
    roleProjection: 'Organizational Arm',
    pitches: {
      fourSeam: { present: 40, future: 40, usage: 50, notes: 'FB 85–87 lacks life' },
      slider: { present: 40, future: 40, usage: 25, notes: 'Breaking pitches are loose' },
      changeup: { present: 35, future: 40, usage: 20, notes: 'CH flashes occasional fade but is below-average overall' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Breaking pitches are loose' }
    },
    tools: {
      command: { present: 35, future: 40 },
      control: { present: 35, future: 35 },
      athleticism: { present: 40, future: 40 },
      delivery: { present: 40, future: 40 },
      fielding: { present: null, future: null }
    },
    summary: 'Slim-bodied lefty with fringe stuff and limited projection. FB 85–87 lacks life, and breaking pitches are loose. CH flashes occasional fade but is below-average overall. Command wavers and struggles against advanced hitters. Profiles as an org arm without a carrying tool unless velo jump occurs.',
    keyStrengths: 'Durable; Willing competitor',
    mainConcerns: 'Lacks velocity; Weak breaking ball feel',
    developmentFocus: 'Strength program to improve FB; Tighten breaking ball shape'
  },

  // Peter Winters
  'peter-winters': {
    pitcherId: 'peter-winters',
    name: 'Peter Winters',
    lastUpdated: new Date().toISOString(),
    ageSize: '19 • 6\'3" • 175 lbs • R',
    stats: '4.20 ERA | 1.32 WHIP | 8.2 K/9 | 3.4 BB/9',
    overallFV: 40,
    risk: 'High',
    roleProjection: 'Development Arm',
    pitches: {
      fourSeam: { present: 45, future: 50, usage: 45, notes: 'FB sits 87–90 with good life, could add a tick or two as body matures' },
      slider: { present: 45, future: 50, usage: 30, notes: 'SL is his most advanced pitch, showing sweep and late bite' },
      changeup: { present: 40, future: 45, usage: 20, notes: 'CH and CB playable but behind' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CH and CB playable but behind' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 55, future: 60 },
      delivery: { present: 40, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Tall, projectable RHP with an average three-pitch mix. FB sits 87–90 with good life, could add a tick or two as body matures. SL is his most advanced pitch, showing sweep and late bite. CH and CB playable but behind. Delivery is raw, command still catching up. Development arm with chance to be more if strength comes.',
    keyStrengths: 'Projectable frame; Developing slider feel',
    mainConcerns: 'Below-average present velo; Command not yet consistent',
    developmentFocus: 'Add strength/velo; Refine delivery for strikes'
  },

  // Vincent White
  'vincent-white': {
    pitcherId: 'vincent-white',
    name: 'Vincent White',
    lastUpdated: new Date().toISOString(),
    ageSize: '20 • 6\'1" • 210 lbs • R',
    stats: '3.85 ERA | 1.30 WHIP | 8.7 K/9 | 3.2 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Depth/Swingman',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 45, notes: 'FB 88–91 plays well when commanded' },
      slider: { present: 45, future: 50, usage: 25, notes: 'SL flashes depth and could be average' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'CH shows fade and has chance to miss bats' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB lags behind but is workable' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Strong-bodied righty with average stuff now and room to tick up. FB 88–91 plays well when commanded. SL flashes depth and could be average. CH shows fade and has chance to miss bats. CB lags behind but is workable. Command flashes average but inconsistent start to start. Projects as org depth with chance to develop into a swingman.',
    keyStrengths: 'Durable frame; Fastball foundation',
    mainConcerns: 'Secondary consistency; Command lapses',
    developmentFocus: 'Improve SL consistency; Refine command'
  },

  // Miles Tracy
  'miles-tracy': {
    pitcherId: 'miles-tracy',
    name: 'Miles Tracy',
    lastUpdated: new Date().toISOString(),
    ageSize: '20 • 6\'4" • 180 lbs • L',
    stats: '4.62 ERA | 1.44 WHIP | 7.2 K/9 | 3.9 BB/9',
    overallFV: 40,
    risk: 'High',
    roleProjection: 'Developmental Prospect',
    pitches: {
      fourSeam: { present: 45, future: 50, usage: 50, notes: 'FB 86–89, projects to 90 with mass' },
      slider: { present: 40, future: 45, usage: 25, notes: 'SL shows occasional sweep' },
      changeup: { present: 40, future: 45, usage: 20, notes: 'CH developing' },
      curveball: { present: 35, future: 40, usage: 5, notes: 'Command is the swing skill' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 35, future: 40 },
      athleticism: { present: 55, future: 60 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Tall, young LHP with room to add strength. FB 86–89, projects to 90 with mass. SL shows occasional sweep; CH developing. Command is the swing skill. Long runway; fits as developmental lefty with possible pen utility.',
    keyStrengths: 'Size/projection; LHP advantage',
    mainConcerns: 'Soft present stuff; Command variance',
    developmentFocus: 'Strength/velo program; Slider shape & release repeatability'
  },

  // Cullen Thomas
  'cullen-thomas': {
    pitcherId: 'cullen-thomas',
    name: 'Cullen Thomas',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'4" • 195 lbs • L',
    stats: '3.90 ERA | 1.33 WHIP | 8.4 K/9 | 3.2 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Starter',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 45, notes: 'FB 88–91 with some arm-side run' },
      slider: { present: 45, future: 50, usage: 25, notes: 'SL/CH both fringe-average trending to average' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'SL/CH both fringe-average trending to average' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB works as a mix-in' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Polished lefty who fills the zone with three playable pitches. FB 88–91 with some arm-side run; SL/CH both fringe-average trending to average. Better strike efficiency than peers; profiles as org starter with bullpen fallback.',
    keyStrengths: 'Strike efficiency; Starter\'s feel',
    mainConcerns: 'Average stuff band; Limited margin for misses',
    developmentFocus: 'Add intent/velo safely; Distinct usage lanes for SL vs CH'
  },

  // Xavier Simmons
  'xavier-simmons': {
    pitcherId: 'xavier-simmons',
    name: 'Xavier Simmons',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'2" • 185 lbs • L',
    stats: '4.70 ERA | 1.45 WHIP | 7.4 K/9 | 3.8 BB/9',
    overallFV: 40,
    risk: 'Medium',
    roleProjection: 'Organizational Filler',
    pitches: {
      fourSeam: { present: 45, future: 45, usage: 45, notes: 'FB 86–89 plays fringy but usable' },
      slider: { present: 40, future: 45, usage: 25, notes: 'SL flashes but lacks consistency' },
      changeup: { present: 40, future: 45, usage: 25, notes: 'CH is developing' },
      curveball: { present: 40, future: 40, usage: 5, notes: 'CB shows minimal bite' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 35, future: 40 },
      athleticism: { present: 45, future: 45 },
      delivery: { present: 40, future: 45 },
      fielding: { present: null, future: null }
    },
    summary: 'Lefty with below-average stuff but serviceable arsenal. FB 86–89 plays fringy but usable. SL flashes but lacks consistency. CH is developing, CB shows minimal bite. Command is spotty. Profiles as org filler lefty with some utility in bullpen innings.',
    keyStrengths: 'LHP presence; Competitive demeanor',
    mainConcerns: 'Inconsistent command; Lacks impact pitch',
    developmentFocus: 'Tighten SL; Improve strike-throwing consistency'
  },

  // Paulo Salazar
  'paulo-salazar': {
    pitcherId: 'paulo-salazar',
    name: 'Paulo Salazar',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'4" • 195 lbs • L',
    stats: '4.38 ERA | 1.40 WHIP | 7.7 K/9 | 3.6 BB/9',
    overallFV: 40,
    risk: 'Medium',
    roleProjection: 'Organizational Depth',
    pitches: {
      fourSeam: { present: 45, future: 45, usage: 40, notes: 'FB 86–89 is steady' },
      slider: { present: 40, future: 45, usage: 25, notes: 'SL/CH show but lack finish' },
      changeup: { present: 40, future: 45, usage: 25, notes: 'SL/CH show but lack finish' },
      curveball: { present: 40, future: 45, usage: 10, notes: 'Strike-throwing serviceable; misses are hittable' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Big-bodied LHP with fringe-average stuff across the board. FB 86–89 is steady; SL/CH show but lack finish. Strike-throwing serviceable; misses are hittable. Depth lefty with bulk innings utility; needs a pitch to separate.',
    keyStrengths: 'Durable frame; LHP depth',
    mainConcerns: 'No carrying pitch; Limited whiff ceiling',
    developmentFocus: 'Sharpen SL (late tilt); Fastball command east-west'
  },

  // Kyle Nicholson
  'kyle-nicholson': {
    pitcherId: 'kyle-nicholson',
    name: 'Kyle Nicholson',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'3" • 205 lbs • R',
    stats: '3.32 ERA | 1.28 WHIP | 10.1 K/9 | 3.6 BB/9',
    overallFV: 50,
    risk: 'Medium',
    roleProjection: 'Starter/Power Relief',
    pitches: {
      fourSeam: { present: 55, future: 60, usage: 45, notes: 'FB 91–94 T96 with late ride; misses bats up' },
      slider: { present: 50, future: 55, usage: 30, notes: 'SL has tight tilt, projects above-average with more consistency' },
      changeup: { present: 45, future: 50, usage: 20, notes: 'CH usable vs LHH' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB a mix-in' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 55, future: 55 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Pro frame and real arm speed. FB 91–94 T96 with late ride; misses bats up. SL has tight tilt, projects above-average with more consistency. CH usable vs LHH; CB a mix-in. Strike quality comes and goes due to timing drift. Starter look if command ticks up; floor of power middle relief.',
    keyStrengths: 'Velo/carry; Strong frame/extension',
    mainConcerns: 'Command variance; SL inconsistency start-to-start',
    developmentFocus: 'Repeat delivery for strikes; Emphasize FB up/SL glove-side tunnel'
  },

  // Caden Pierce
  'caden-pierce': {
    pitcherId: 'caden-pierce',
    name: 'Caden Pierce',
    lastUpdated: new Date().toISOString(),
    ageSize: '20 • 6\'2" • 185 lbs • R',
    stats: '3.75 ERA | 1.29 WHIP | 9.6 K/9 | 3.2 BB/9',
    overallFV: 50,
    risk: 'Medium',
    roleProjection: 'Dependable Starter',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 40, notes: 'FB 89–92 T94' },
      slider: { present: 50, future: 55, usage: 30, notes: 'SL is primary bat-misser with tight two-plane break' },
      changeup: { present: 45, future: 50, usage: 25, notes: 'CH average projection' },
      curveball: { present: 45, future: 50, usage: 5, notes: 'CB shows depth' }
    },
    tools: {
      command: { present: 45, future: 50 },
      control: { present: 45, future: 50 },
      athleticism: { present: 50, future: 55 },
      delivery: { present: 50, future: 55 },
      fielding: { present: null, future: null }
    },
    summary: 'Well-rounded four-pitch mix with feel to land everything. FB 89–92 T94, SL is primary bat-misser with tight two-plane break. CB shows depth; CH average projection. Clean delivery and competitive tempo. Projects as dependable starter type with chance to jump if velo bumps.',
    keyStrengths: 'Balanced mix; Slider feel/utility',
    mainConcerns: 'No present plus pitch; Needs physicality to add a tick',
    developmentFocus: 'Strength/velo gains; Distinct SL vs CB usage lanes'
  },

  // Jayden Parker
  'jayden-parker': {
    pitcherId: 'jayden-parker',
    name: 'Jayden Parker',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'0" • 180 lbs • R',
    stats: '4.10 ERA | 1.36 WHIP | 8.7 K/9 | 3.4 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Depth/Swingman',
    pitches: {
      fourSeam: { present: 45, future: 50, usage: 40, notes: 'FB 88–91 plays best east-west' },
      slider: { present: 45, future: 50, usage: 30, notes: 'SL average projection with occasional late tilt' },
      changeup: { present: 40, future: 45, usage: 25, notes: 'CH lags' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB loops for strikes' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 45, future: 45 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Strike-thrower with two playable breakers. FB 88–91 plays best east-west; SL average projection with occasional late tilt. CB loops for strikes; CH lags. Not flashy but competes and sequences. Likely org depth starter with swingman utility.',
    keyStrengths: 'Two breaking balls for strikes; Sequencing savvy',
    mainConcerns: 'Below-average velo; Limited whiff potential',
    developmentFocus: 'Fastball life (seam-shift/carry); Harden slider finish'
  },

  // Kevin Ray
  'kevin-ray': {
    pitcherId: 'kevin-ray',
    name: 'Kevin Ray',
    lastUpdated: new Date().toISOString(),
    ageSize: '23 • 6\'1" • 200 lbs • R',
    stats: '4.25 ERA | 1.38 WHIP | 9.1 K/9 | 3.8 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Relief/Swingman',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 50, notes: 'FB 90–93 T95 can play in-zone when elevated' },
      slider: { present: 45, future: 50, usage: 30, notes: 'SL flashes average with cutter-ish shape at times' },
      changeup: { present: 40, future: 45, usage: 15, notes: 'Strike rate is volatile' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'Will need to live in simpler lanes' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 50 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Strong-bodied righty with late hop at the top rail. FB 90–93 T95 can play in-zone when elevated. SL flashes average with cutter-ish shape at times. Strike rate is volatile; will need to live in simpler lanes. Relief floor with chance for more if command stabilizes.',
    keyStrengths: 'FB life up; Physical strength',
    mainConcerns: 'Scatter-shot strikes; Secondary definition',
    developmentFocus: 'FB/SL two-pitch plan; Command constraints (glove-side aim bias)'
  },

  // Preston Reed
  'preston-reed': {
    pitcherId: 'preston-reed',
    name: 'Preston Reed',
    lastUpdated: new Date().toISOString(),
    ageSize: '22 • 6\'4" • 210 lbs • R',
    stats: '3.98 ERA | 1.35 WHIP | 8.9 K/9 | 3.5 BB/9',
    overallFV: 45,
    risk: 'Medium',
    roleProjection: 'Organizational Starter',
    pitches: {
      fourSeam: { present: 50, future: 55, usage: 40, notes: 'FB 89–92 plays plane-down when downhill' },
      slider: { present: 45, future: 50, usage: 25, notes: 'SL/CH both flash average' },
      changeup: { present: 45, future: 50, usage: 30, notes: 'SL/CH both flash average' },
      curveball: { present: 40, future: 45, usage: 5, notes: 'CB a show-me' }
    },
    tools: {
      command: { present: 40, future: 45 },
      control: { present: 40, future: 45 },
      athleticism: { present: 50, future: 55 },
      delivery: { present: 45, future: 50 },
      fielding: { present: null, future: null }
    },
    summary: 'Big frame with starter look and average stuff trending up. FB 89–92 plays plane-down when downhill. SL/CH both flash average; CB a show-me. Command is just shy of average but improving. Projects as org starter with path to back-end if CH or SL jumps.',
    keyStrengths: 'Size/durability; Two secondaries trending',
    mainConcerns: 'Below-plus raw stuff; Command catches too much plate',
    developmentFocus: 'Tighten tunnel pairs (FB/SL up & glove, FB/CH down & arm)'
  }
};
